var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "app-container",
    },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          selection: _vm.selection,
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: false,
          "before-reset-search": _vm.beforeResetSearch,
          "row-style": _vm.rowStyleFun,
          "default-sort": _vm.defaultSort,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          handleSelectionChange: _vm.handleSelectionChange,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          "sort-change": _vm.sortChange,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.searchIDs"),
                          prop: "invoiceId",
                        },
                      },
                      [
                        _c("BjInputNumber", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("billingPage.searchID"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.invoiceId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "invoiceId", $$v)
                            },
                            expression: "queryParams.invoiceId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.companySeller"),
                          prop: "companyName",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.clientCodeList,
                            placeholder: _vm.$t("billingPage.companySeller"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.companyName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "companyName", $$v)
                            },
                            expression: "queryParams.companyName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.yearAndWeek"),
                          prop: "year",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            id: "getWeekDate",
                            "picker-options": { firstDayOfWeek: 1 },
                            type: "week",
                            format: "yyyy-WW",
                            clearable: false,
                            placeholder: _vm.$t("billingPage.yearAndWeeks"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.weekDataNow,
                            callback: function ($$v) {
                              _vm.weekDataNow = $$v
                            },
                            expression: "weekDataNow",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onGenerate },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("billingPage.generateLastlnvoices"))
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onPending },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("billingPage.generatePendingBilling")
                              )
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onBilling },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("billingPage.generateBilling"))
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onBatchPDF },
                          },
                          [_vm._v(_vm._s(_vm.$t("billingPage.batchPDF")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onBatchBreakdown },
                          },
                          [_vm._v(_vm._s(_vm.$t("billingPage.batchBreakdown")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onBatchRemove },
                          },
                          [_vm._v(_vm._s(_vm.$t("billingPage.batchRemove")))]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t(
                                "billingPage.generateContainerPreviewHint"
                              ),
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "main-btn",
                                attrs: {
                                  type: "primary",
                                  loading: _vm.containerPreviewLoading,
                                },
                                on: { click: _vm.onContainerPreview },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "billingPage.generateContainerPreview"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.showProgress
                  ? _c("el-row", { staticStyle: { padding: "10px 5px 0" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("billingPage.MailProgress")) +
                          ": " +
                          _vm._s(_vm.progress)
                      ),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    !["bjTableAction", "totalAmount"].includes(col.prop)
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "invoiceReviewStatus"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.isReviewed(scope.row)
                                                ? "success"
                                                : "warning",
                                              size: "small",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.isReviewed(scope.row)
                                                    ? "invoiceReview.reviewed"
                                                    : "invoiceReview.unreviewed"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "state"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                scope.row.state == "PAID"
                                                  ? "success"
                                                  : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.BILLING_PAGE_STATUS.bjGet(
                                                      scope.row.state
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : col.prop === "week"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.year) +
                                              "-" +
                                              _vm._s(scope.row.week)
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "totalAmount"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "total_amount",
                            title: col.label,
                            sortable: "",
                            width: "135px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm.money(scope.row[col.prop]))
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: Math.max(Number(col.width) || 0, 180),
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _vm.canViewReview
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: _vm.$t(
                                                "invoiceReview.openReview"
                                              ),
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("el-button", {
                                              staticClass: "edit-btn",
                                              staticStyle: {
                                                "font-size": "20px",
                                              },
                                              attrs: {
                                                type: "text",
                                                icon: "el-icon-document-checked",
                                                "aria-label": _vm.$t(
                                                  "invoiceReview.openReview"
                                                ),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openReview(
                                                    props.row
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "PDF",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticClass: "edit-btn",
                                          staticStyle: { "font-size": "20px" },
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-download",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onPDF(props.row)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "CSV",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticClass: "edit-btn",
                                          staticStyle: { "font-size": "20px" },
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-document",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onCSV(props.row)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "XLSX",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticClass: "edit-btn",
                                          staticStyle: { "font-size": "20px" },
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-files",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onXLSX(props.row)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }